<template>
  <div v-on:click="handleClick" style="cursor: pointer;">
    <i v-if="loading" class="el-icon-loading"></i>
    <img v-else-if="status === 1" :src="EyesHide" />
    <img v-else :src="EyesShow" />
  </div>
</template>

<script>
export default {
  name: "ShowOriginal",
  props: {
    cb: Function,
    show_original: Number
  },
  data() {
    return {
      EyesHide: "https://res.klook.com/image/upload/eyes-hide_rqwyaw.svg",
      EyesShow: "https://res.klook.com/image/upload/eyes-show_yvsiyx.svg",
      status: this.show_original || 2, // 1 显示 2  隐藏 0 loading
      loading: false
    };
  },
  methods: {
    async handleClick(e) {
      const prevStatus = this.status;
      this.status = prevStatus === 1 ? 2 : 1;
      this.loading = true;
      if (this.cb) {
        await this.cb().then(() => {
          this.loading = false;
        });
      }
    }
  }
};
</script>

<style scoped></style>
